import SectionSeparator from "../SectionSeparator";
import DocumentUploadBlock from "../DocumentUploadBlock";

const RequiredDocumentsStep = ({ ctx }) => {
  const {
    tenantId,
    DOCUMENT_TYPES,
    doc,
    setDoc,
    formData,
    attachments,
    setAttachments,
  } = ctx;

  return (
    <>
      <SectionSeparator title="title.child_documents" />

      <DocumentUploadBlock
        tenantId={tenantId}
        options={DOCUMENT_TYPES.child}
        value={doc.child.type}
        description={doc.child.desc}
        center_id={formData.centerData.center_id}
        center_uuid={formData.centerData.center_uuid}
        centerLogo={formData.centerData.logo}
        tableName="children"
        tableId={formData.childData.child_id}
        attachments={attachments.child}
        setAttachments={(files) =>
          setAttachments((prev) => ({
            ...prev,

            child: files,
          }))
        }
        file={doc.child.file}
        setFile={(file) =>
          setDoc((prev) => ({
            ...prev,

            child: { ...prev.child, file },
          }))
        }
        onTypeChange={(e) =>
          setDoc((prev) => ({
            ...prev,

            child: { ...prev.child, type: e.target.value },
          }))
        }
        onDescChange={(e) =>
          setDoc((prev) => ({
            ...prev,

            child: { ...prev.child, desc: e.target.value },
          }))
        }
      />

      <SectionSeparator title="title.sponsor_documents" />

      <DocumentUploadBlock
        tenantId={tenantId}
        options={DOCUMENT_TYPES.father}
        value={doc.father.type}
        description={doc.father.desc}
        center_id={formData.centerData.center_id}
        center_uuid={formData.centerData.center_uuid}
        centerLogo={formData.centerData.logo}
        tableName="parents"
        tableId={formData.parentData.parent_id}
        attachments={attachments.father}
        setAttachments={(files) =>
          setAttachments((prev) => ({
            ...prev,

            father: files,
          }))
        }
        file={doc.father.file}
        setFile={(file) =>
          setDoc((prev) => ({
            ...prev,

            father: { ...prev.father, file },
          }))
        }
        onTypeChange={(e) =>
          setDoc((prev) => ({
            ...prev,

            father: { ...prev.father, type: e.target.value },
          }))
        }
        onDescChange={(e) =>
          setDoc((prev) => ({
            ...prev,

            father: { ...prev.father, desc: e.target.value },
          }))
        }
      />

      <SectionSeparator title="title.spouse_documents" />

      <DocumentUploadBlock
        tenantId={tenantId}
        options={DOCUMENT_TYPES.mother}
        value={doc.mother.type}
        description={doc.mother.desc}
        center_id={formData.centerData.center_id}
        center_uuid={formData.centerData.center_uuid}
        centerLogo={formData.centerData.logo}
        tableName="parents"
        tableId={formData.parentData.parent_id}
        attachments={attachments.mother}
        setAttachments={(files) =>
          setAttachments((prev) => ({
            ...prev,

            mother: files,
          }))
        }
        file={doc.mother.file}
        setFile={(file) =>
          setDoc((prev) => ({
            ...prev,

            mother: { ...prev.mother, file },
          }))
        }
        onTypeChange={(e) =>
          setDoc((prev) => ({
            ...prev,

            mother: { ...prev.mother, type: e.target.value },
          }))
        }
        onDescChange={(e) =>
          setDoc((prev) => ({
            ...prev,

            mother: { ...prev.mother, desc: e.target.value },
          }))
        }
      />
    </>
  );
};

export default RequiredDocumentsStep;
